/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const breadcrumbTrailContainerSX: SxProps = {
	ml:globalBreak({mobile:0,desktop:1}),
	mb:globalBreak({mobile:0,desktop:1}),
	'&:first-of-type': {
		mt: 0,
		pb:globalBreak({mobile:1,desktop:0})
	},
	'& ol li a':{
		textDecoration:'none',
		fontSize:14,
	},
	'& ol li span':{
		fontSize:14,
	},
	fontSize:14,	
};

export const breadcrumbTrailContainerMobSX:SxProps = {
	maxWidth: '98%',
	overflowX: 'scroll',
	WebkitOverflowScrolling: 'touch',
	pb:1,
	marginBottom:'-15px',
	'& li': {
		display: 'table-cell',
		px:globalBreak({mobile:'3px', desktop:1}),
		verticalAlign:'middle'
	},'& li:first-of-type': {
		pl:0,
	},
	'& ol': {
		padding: 0,
		display: 'table',
	},
	'& nav': {
		width: '300px',
		overflowX: 'scroll',
		WebkitOverflowScrolling: 'touch',
	},
	'&::-webkit-scrollbar': {
		display:'none'
	},
	'& li > a, li > span': {
		whiteSpace: 'nowrap',
	},
	'& li svg':{
		mt:0.8
	},
	'& ol li a':{
		textDecoration:'none',
		fontSize:12,
	},
	'& ol li span':{
		fontSize:12,
	},
	fontSize:12
}

export const scrollRightBtnSx:SxProps = {
	position:'absolute', 
	top:0,
	right:'-1.2em',
	'& > svg':{
		fontSize:32
	}
}

export const scrollLeftBtnSx:SxProps = {
	position:'absolute', 
	left:'-1.2em',
	'& > svg':{
		fontSize:32,
		transform:'rotate(180deg)'
	}
}

export const breadcrumbTrailParentContainerSX:SxProps = {
	position:'relative' , 
}

